interface Props {
  label: string
  isCurrent: boolean
  onPrevious: () => void
  onNext: () => void
  onToday: () => void
}

export function PeriodNav({ label, isCurrent, onPrevious, onNext, onToday }: Props) {
  return (
    <div className="flex items-center gap-1">
      <Arrow direction="previous" onClick={onPrevious} />
      <Arrow direction="next" onClick={onNext} />
      <span className="px-1 text-[14px] font-medium tnum">{label}</span>
      {!isCurrent ? (
        <button
          type="button"
          onClick={onToday}
          className="rounded-md border border-line px-2 py-1 text-[12px] font-medium text-dim transition-colors duration-150 hover:border-line-strong hover:text-text"
        >
          Today
        </button>
      ) : null}
    </div>
  )
}

function Arrow({ direction, onClick }: { direction: 'previous' | 'next'; onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={direction === 'previous' ? 'Previous' : 'Next'}
      className="flex size-7 items-center justify-center rounded-md text-dim transition-colors duration-150 hover:bg-raised hover:text-text"
    >
      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d={direction === 'previous' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7'} />
      </svg>
    </button>
  )
}
